import { InputLabel } from "@mui/material";

export default function InputFieldLabel({ label }: InputFieldLabelProps) {
  return <InputLabel>{label}</InputLabel>;
}

interface InputFieldLabelProps {
  label: string;
}
